import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SidebarMenu } from '@shared/layout/sidebar-menu/sidebar-menu.type';
import { LocalStorageService } from '@shared/services/local-storage.service';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'rav-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  @Input() menus: SidebarMenu[];
  @Input() logoSrc: string;
  @Output() collapsed: EventEmitter<boolean> = new EventEmitter();

  isCollapsed: boolean;
  arrowSrc = '';

  constructor(private storage: LocalStorageService, private deviceService: DeviceDetectorService) {
    this.arrowSrc = '/assets/icons/arrow-double-left.svg';
  }

  ngOnInit(): void {
    // Initialize after a timeout 0 prevents the "Value changed after view checked" error
    setTimeout(() => {
      this.initializeSidebarState();
    }, 0);
  }

  /**
   * Changes the value of the flag to collapse sidebar
   *
   * @param isCollapsed boolean forced state for the sidebar
   */
  collapse(isCollapsed?: boolean): void {
    // When the param is different than undefined set that value by default
    this.isCollapsed = isCollapsed !== undefined ? isCollapsed : !this.isCollapsed;
    // Updates the state in local storage for future sessions
    this.storage.isSidebarCollapsed = this.isCollapsed;
    this.collapsed.emit(this.isCollapsed);
    this.arrowSrc = this.isCollapsed ? '/assets/icons/arrow-double-right.svg' : '/assets/icons/arrow-double-left.svg';
  }

  /**
   * Sets the initial state for the sidebar depending on local storage value
   * or window size (collapsed by default on tablets)
   */
  private initializeSidebarState(): void {
    let state = this.storage.isSidebarCollapsed;
    // If the value does not exist in storage takes the value for tablet displays
    if (state === null || state === undefined) state = this.deviceService.isTablet();

    // If the user is on a mobile size the state must be always false
    if (this.deviceService.isMobile()) state = false;

    this.collapse(state);
  }
}
